import React from 'react';
import {
    Modal,
    Paper,
    Typography,
    Box,
    Button,
    Divider,
    Chip
} from '@mui/material';

const AutonomyPromotionModal = ({
                                    open,
                                    onClose,
                                    onConfirm,
                                    onNotify, // ✅ ADD THIS
                                    approvalHistory = [],
                                    requiredApprovals = 3
                                }) => {
    const smoothApprovals = approvalHistory.filter(a => a.action === 'approve' && !a.hadEdits);
    const currentConsensus = smoothApprovals.filter(a => a.votedForAutonomy).length;
    const remainingApprovals = Math.max(0, requiredApprovals - currentConsensus);

    return (
        <Modal open={open} onClose={onClose}>
            <Paper
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 700,
                    maxWidth: '95vw',
                    p: 4,
                    bgcolor: '#202020',
                    color: '#fff',
                    border: '1px solid #333',
                    borderRadius: 2
                }}
            >
                <Typography variant="h6" sx={{ color: '#12c099', mb: 2 }}>
                    Promote Task to Autonomous Execution
                </Typography>

                <Typography variant="body2" sx={{ color: '#ccc', mb: 3 }}>
                    This task has been approved multiple times. Below is a record of approvals, edits, and denials.
                    The system requires <strong>{requiredApprovals} team members</strong> to approve autonomy.
                </Typography>

                <Box sx={{ maxHeight: 250, overflowY: 'auto', mb: 3 }}>
                    {approvalHistory.map((entry, i) => (
                        <Box key={i} sx={{ mb: 2 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography variant="body2" sx={{ color: '#eee' }}>
                                    {entry.date} — {entry.user}
                                </Typography>

                                {entry.action === 'deny' ? (
                                    <Chip label="Denied" color="error" size="small" />
                                ) : entry.hadEdits ? (
                                    <Chip label="Approved (Edited)" color="warning" size="small" />
                                ) : (
                                    <Chip label="Approved" color="success" size="small" />
                                )}
                            </Box>
                            {entry.denialReason && (
                                <Typography variant="body2" sx={{ color: '#f88', mt: 0.5 }}>
                                    Reason: {entry.denialReason}
                                </Typography>
                            )}
                            {entry.hadEdits && (
                                <Typography variant="body2" sx={{ color: '#ffb74d', mt: 0.5 }}>
                                    Edit: {entry.editsSummary || 'Payload was modified before submission.'}
                                </Typography>
                            )}
                            <Divider sx={{ borderColor: '#444', mt: 1 }} />
                        </Box>
                    ))}
                </Box>

                <Typography variant="subtitle2" sx={{ color: '#ccc', mb: 2 }}>
                    ✅ <strong>{currentConsensus}</strong> / {requiredApprovals} approvals collected for autonomous promotion.
                </Typography>

                {remainingApprovals > 0 && (
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body2" sx={{ color: '#aaa', mb: 1 }}>
                            Waiting on approval from {remainingApprovals} more team member{remainingApprovals > 1 ? 's' : ''}.
                        </Typography>

                        {/* Placeholder for "Notify" feature */}
                        <Button
                            variant="outlined"
                            size="small"
                            sx={{ color: '#12c099', borderColor: '#12c099' }}
                            onClick={onNotify} // ← FIXED HERE
                        >
                            Notify Reviewer
                        </Button>
                    </Box>
                )}

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button onClick={onClose} variant="outlined">Cancel</Button>
                    <Button
                        onClick={onConfirm}
                        variant="contained"
                        color="success"
                        disabled={remainingApprovals > 0}
                    >
                        Upgrade to Autonomous
                    </Button>
                </Box>
            </Paper>
        </Modal>
    );
};

export default AutonomyPromotionModal;
